import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Board } from '../components/board/Board';
export function BoardDemo() {
    return (_jsx("div", { className: "h-screen bg-gray-100", children: _jsx(Board, {}) }));
}
